function toggle_expandable(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);
    const toggleWrapper = elm.parents('.expandable-toggle-wrapper');
    const wrapper = toggleWrapper.next();

    toggleWrapper.toggleClass('open', !toggleWrapper.hasClass('open'));
    wrapper.toggleClass('open', !wrapper.hasClass('open'));
}